import { IlluminateUserPermissionsEnum } from "@/api/openapi";
import { IUserInfo, useUser } from "@/contexts/user";

export const hasPermission = (
    user: IUserInfo | undefined,
    ...permissions: IlluminateUserPermissionsEnum[]
) => {
    if (!user?.permissions) return false;

    if (Array.isArray(permissions)) {
        return permissions.some((p) => user.permissions.includes(p));
    }

    return user.permissions.includes(permissions);
};

export const canAccessAllOrgsAndDevices = (
    { accessTags }: { accessTags: string[] } | undefined = { accessTags: [] },
) => !!accessTags.includes("JETCharge");

export const useCanAccessAllDevicesInOwnOrg = () => {
    const { user, isLoading } = useUser();
    return {
        canAccessAllDevicesInOwnOrg:
            canAccessAllOrgsAndDevices(user) ||
            (user?.organisationId &&
                user?.deviceGroupTags.includes(user.organisationId)),
        isLoading,
    };
};
